export default function ServiceClass() {
    this.url = 'https://api.foroom.ru/';

    this.url = 'https://sale.foroom.ru/proxy/proxy.php';

    //this.url='http://mfc.vrembo.ru/api/';

    this.key = 'W5pRNSx8Dx3tGY65xx3BOgAAAAE';




    this.makePost = function(module, action, userdata, loader, cb) {
        var self = this;
        self.reqProc = true;
        if (typeof loader !== "undefined" && loader != null) loader.show();

        userdata.module = module;
        userdata.cmd = action;
        userdata.key = self.key;

        var data = new FormData();
        data.append('json', JSON.stringify(userdata));
        if (!navigator.onLine) {
            if (typeof cb !== "undefined" && cb != null) cb({ status: 'OFFLINE', descr: '' });
        } else {
            var xmlhttp = new XMLHttpRequest();

            xmlhttp.onreadystatechange = function() {
                if (xmlhttp.readyState === XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
                    if (xmlhttp.status === 200) {
                        var headers = xmlhttp
                            .getAllResponseHeaders()
                            .split('\r\n')
                            .reduce((result, current) => {
                                var [name, value] = current.split(': ');
                                result[name] = value;
                                return result;
                            }, {});
                        var contentType = 'application/json';
                        if (headers["content-type"]) contentType = headers["content-type"];

                        var respond = { status: 'OK' };
                        if (contentType === 'application/json') {
                            respond = JSON.parse(xmlhttp.responseText);
                        } else {
                            var filename = 'file.txt';
                            console.log(xmlhttp.responseType);

                            if (headers["filename"]) filename = headers["filename"];
                            var blob = new Blob([xmlhttp.response], { type: contentType });
                            //var file = new File([blob],filename,{type:contentType});
                            self.downloadAsFile(blob, filename);
                        }
                        if (typeof loader !== "undefined" && loader != null) loader.hide();


                        if (typeof cb !== "undefined" && cb != null) cb(respond);
                    } else {
                        if (cb) cb({ status: 'ERROR' });
                        console.log('РћРЁРР‘РљР AJAX Р·Р°РїСЂРѕСЃР°:');
                    }
                }
            };

            xmlhttp.open("POST", self.url, true);
            xmlhttp.send(data);




            /*
            	
            	
            	
            		$.ajax({
            			url: self.url,//+'?'+module+'&'+action+'&'+self.key,
            			type: 'POST',
            			data: data,
            			cache: false,
            			dataType: 'json',
            			processData: false,
            			contentType: false,
            			success: function( respond, textStatus, jqXHR ){
            				if (typeof loader !== "undefined" && loader != null) loader.hide();
            				if (typeof cb !== "undefined" && cb != null) cb(respond);
            			},
            			error: function( jqXHR, textStatus, errorThrown ){
            				if (typeof loader !== "undefined" && loader != null) loader.hide();
            				if (typeof cb !== "undefined" && cb != null)	cb({status:'ERROR', descr:textStatus});
            				console.log('РћРЁРР‘РљР AJAX Р·Р°РїСЂРѕСЃР°:', textStatus );
            			}
            		});
            		
            		*/



        }






    }

    this.downloadAsFile = function(file, filename) {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        a.download = filename;
        a.click();
    }
    this.screenSize = function() {
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;
        return { x: parseInt(x), y: parseInt(y) };
    }

    this.set = function(k, v) {
        if (typeof v !== "undefined" && v != null)
            return window.localStorage.setItem(k, JSON.stringify(v));
        else return false
    }

    this.get = function(k) {
        return JSON.parse(window.localStorage.getItem(k));
    }

    this.remove = function(k) {
        return window.localStorage.removeItem(k);
    }

    this.clear = function() {
        return window.localStorage.clear();
    }


    this.in_array = function(s, ar) {
        var idx = ar.indexOf(s);
        if (idx != -1) return true;
        return false;
    }

    this.isset = function(a) {
        if (typeof a === 'undefined') return false;
        else
        if (a == null) return false;
        else
            return true;
    }

    this.parseBool = function(b) {
        if (b == 'true' || b === 'true' || parseFloat(b) > 0) return true;
        return false;
    }

    this.number_format = function(number, decimals, dec_point, thousands_sep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function(n, prec) {
                var k = Math.pow(10, prec);
                return '' + (Math.round(n * k) / k)
                    .toFixed(prec);
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
            .split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '')
            .length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1)
                .join('0');
        }
        return s.join(dec);
    }

    /*
    		USING: 
    	this.set_cookie ( "cookie_name", "cookie value");
    		OR
    	this.set_cookie ( "cookie_name", "cookie value", 2018, 12, 20, "");
    		OR
    	this.set_cookie ( "cookie_name", "cookie value", 2018, 12, 20, "","example.com", "secure" );
    */
    this.set_cookie = function(name, value, exp_y, exp_m, exp_d, path, domain, secure) {
        var cookie_string = name + "=" + escape(value);
        if (exp_y) {
            var expires = new Date(exp_y, exp_m, exp_d);
            cookie_string += "; expires=" + expires.toGMTString();
        }
        if (path)
            cookie_string += "; path=" + escape(path);
        if (domain)
            cookie_string += "; domain=" + escape(domain);
        if (secure)
            cookie_string += "; secure";
        document.cookie = cookie_string;
    }

    this.delete_cookie = function(cookie_name) {
        var cookie_date = new Date();
        cookie_date.setTime(cookie_date.getTime() - 1);
        document.cookie = cookie_name += "=; expires=" + cookie_date.toGMTString();
    }

    this.get_cookie = function(cookie_name) {
        var results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');
        if (results)
            return (unescape(results[2]));
        else
            return null;
    }

    this.destroy = function() {}
}